import { PlaylistFetchFn } from "../PlaylistCore/interface";
import {
    fetchAndParseForYouVideos,
    fetchVideoByCategoryFactory,
    fetchVideoByLineupFactory,
} from "../PlaylistCore/utils";

export interface ShortsNavConstantProps {
    label: string;
    fetchFn: PlaylistFetchFn;
}

interface ShortsNavigationLookup {
    [key: string]: ShortsNavConstantProps[];
}

const homepage: ShortsNavConstantProps[] = [
    {
        label: "Featured",
        fetchFn: fetchVideoByLineupFactory("vertical-video-queue", 30, [
            "RATIO_9_BY_16",
        ]),
    },
    {
        label: "For You",
        fetchFn: fetchAndParseForYouVideos,
    },
    {
        label: "Entertainment",
        fetchFn: fetchVideoByCategoryFactory("general-entertainment", 30, [
            "RATIO_9_BY_16",
        ]),
    },
    {
        label: "Lifestyle",
        fetchFn: fetchVideoByCategoryFactory("general-lifestyle", 30, [
            "RATIO_9_BY_16",
        ]),
    },
    {
        label: "Culture",
        fetchFn: fetchVideoByCategoryFactory("culture", 30, ["RATIO_9_BY_16"]),
    },
    {
        label: "News",
        fetchFn: fetchVideoByCategoryFactory("news", 30, ["RATIO_9_BY_16"]),
    },
    {
        label: "Sports",
        fetchFn: fetchVideoByCategoryFactory("sports", 30, ["RATIO_9_BY_16"]),
    },
    {
        label: "Indigenous",
        fetchFn: fetchVideoByCategoryFactory("indigenous", 30, [
            "RATIO_9_BY_16",
        ]),
    },
    {
        label: "Science",
        fetchFn: fetchVideoByCategoryFactory("root-science", 30, [
            "RATIO_9_BY_16",
        ]),
    },
    {
        label: "Music",
        fetchFn: fetchVideoByCategoryFactory("music", 30, ["RATIO_9_BY_16"]),
    },
];

export const SHORTS_WIDGET_NAVIGATION: ShortsNavigationLookup = {
    homepage,
};

export const SHORTS_FILTERS_LINKS_TRACKING_DATA_ATTRS = {
    "data-feature-name": "radio-button",
    "data-feature-instance": "video-categories",
};

export const placeholderItem = {
    id: "",
    title: "",
    url: "",
    image: {
        url: "",
    },
};
